import { safeLocalStorage } from './safeLocalStorage'
import type { RvUserType } from '@strata-monorepo/shared-types/src/rvUserType'

declare global {
  interface Window {
    strataUtils?: StrataUtils
  }
}

export interface StrataUtils {
  toggleRvUserType: () => RvUserType
  setRvUserType: (userType: RvUserType) => void
  getRvUserType: () => RvUserType
  isInternalRv: () => boolean
}

const STORAGE_KEY = 'strata_rv_user_type'

export const getRvUserType = (): RvUserType => {
  if (typeof window === 'undefined') return 'external'

  const stored = safeLocalStorage.getItem(STORAGE_KEY, 'external')
  if (stored === 'internal-rv' || stored === 'external') {
    return stored as RvUserType
  }

  return 'external'
}

export const setRvUserType = (userType: RvUserType): void => {
  if (typeof window !== 'undefined') {
    safeLocalStorage.setItem(STORAGE_KEY, userType)
  }
}

export const toggleRvUserType = (): RvUserType => {
  const currentType = getRvUserType()
  const newType: RvUserType = currentType === 'internal-rv' ? 'external' : 'internal-rv'
  setRvUserType(newType)
  return newType
}

export const isInternalRv = (): boolean => {
  return getRvUserType() === 'internal-rv'
}

export const initializeRvUserType = (): void => {
  if (typeof window === 'undefined') return

  const params = new URLSearchParams(window.location.search)
  const rvTestUser = params.get('rv_test_user')
  if (rvTestUser === 'true') {
    setRvUserType('internal-rv')
    return
  }

  // Only clear strata_rv_user_type from localStorage if user explicitly set rv_test_user=false
  if (rvTestUser === 'false') {
    safeLocalStorage.removeItem(STORAGE_KEY)
    return
  }
}

export const createStrataUtils = (): StrataUtils => ({
  toggleRvUserType,
  setRvUserType,
  getRvUserType,
  isInternalRv,
})

export const setupStrataUtils = (): void => {
  if (typeof window !== 'undefined') {
    window.strataUtils = createStrataUtils()
  }
}
